export const loadCrashPage = async (error?: unknown) => {
  try {
    const errorHtml = (await import("./error.html")).default;
    const iframe = document.createElement("iframe");

    iframe.srcdoc = errorHtml;
    iframe.style.height = "100%";
    iframe.style.width = "100%";

    const shellElement = document.getElementById("shell");

    if (shellElement) {
      shellElement.replaceWith(iframe);
    }

    iframe.onload = () => {
      if (error instanceof Error) {
        // @ts-expect-error - function is declared in the html
        iframe.contentWindow?.displayError(error.message);
      }
    };
  } catch (error) {
    console.error("Failed to load crash page", error);
  }
};
